import { render } from "./ImageGalleryDesktop.vue?vue&type=template&id=5a665647&scoped=true&ts=true"
import script from "./ImageGalleryDesktop.vue?vue&type=script&lang=ts"
export * from "./ImageGalleryDesktop.vue?vue&type=script&lang=ts"

import "./ImageGalleryDesktop.vue?vue&type=style&index=0&id=5a665647&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a665647"]])

export default __exports__